export default "__VITE_ASSET__B_OH5EL0__"